import { render } from "./Index.vue?vue&type=template&id=7152ce7a"
const script = {}

import exportComponent from "/codebuild/output/src2796879663/src/bitbucket.org/island-c/cayman-fe-operator/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__